import React from 'react'
import styles from '../../Styles/Button.module.css'

const Button = (props) => {
const {text, type, handleButtonClick, colored} = props
  return (
    <button type={type} onClick={handleButtonClick} className={colored ? styles.colored : styles.offColored}>{text}</button>
  )
}

export default Button